import { api } from './client';

/** Gastos y APIs (solo OWNER). Prefijo: /api/owner/gastos */

export interface GastoFijo {
  nombre: string;
  usdMes: number;
}

export interface GastosConfig {
  cobroMensualUsd: number | null;
  fijos: GastoFijo[];
}

export interface ServicioExterno {
  nombre: string;
  tipo: string;
  estado: 'ok' | 'apagada' | 'error';
  detalle: string;
  ultimoUsoAt: string | null;
}

export interface PanelGastos {
  config: GastosConfig;
  ia: { usd: number; turnosApi: number; usosCli: number; modelosSinPrecio: string[] };
  cuenta: {
    fijosUsd: number;
    iaUsd: number;
    totalUsd: number;
    gananciaUsd: number | null;
    margenPct: number | null;
  };
  servicios: ServicioExterno[];
}

export const getGastos = () => api.get<PanelGastos>('/api/owner/gastos');

export const putGastos = (config: GastosConfig) =>
  api.put<GastosConfig>('/api/owner/gastos', config);
